import React from 'react';
import { Descriptions, Spin, Typography, Tag } from 'antd';
import Drawer from '../../../components/AppDrawer';
import type { OfferingCategoryDetail } from '../types';
import AuditProperties from '../../../components/AuditProperties';

const { Text } = Typography;

export interface OfferingCategoryViewDrawerProps {
  open: boolean;
  onClose: () => void;
  offeringCategory: OfferingCategoryDetail | null | undefined;
  loading: boolean;
  onEdit: () => void;
}

const OfferingCategoryViewDrawer: React.FC<OfferingCategoryViewDrawerProps> = ({
  open,
  onClose,
  offeringCategory,
  loading,
  onEdit,
}) => {

  return (
    <Drawer
      title="Category details"
      placement="right"
      size="large"
      open={open}
      onClose={onClose}
      extra={
        <Typography.Link onClick={onEdit} style={{ marginRight: 8 }}>
          Edit
        </Typography.Link>
      }
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      ) : offeringCategory === null || offeringCategory === undefined ? (
        <Text type="secondary">Category not found.</Text>
      ) : (
        <>
          <div className="cp-form-section">
            <Descriptions column={2} size="small" title="Basic information">
              <Descriptions.Item label="Title" span={2}>
                <Text strong>{offeringCategory.title}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {offeringCategory.isActive ? (
                  <Tag color="green">Active</Tag>
                ) : (
                  <Tag color="default">Inactive</Tag>
                )}
              </Descriptions.Item>
            </Descriptions>
          </div>

          {offeringCategory.description && (
            <div className="cp-form-section">
              <Text strong>Description</Text>
              <div style={{ marginTop: 4 }}>
                <Text type="secondary">{offeringCategory.description}</Text>
              </div>
            </div>
          )}

          <AuditProperties
            className="cp-form-section"
            values={{
              createdAtUtc: offeringCategory.createdAtUtc,
              createdByDisplayName: offeringCategory.createdByDisplayName,
              createdByUserId: offeringCategory.createdByUserId,
              lastModifiedAtUtc: offeringCategory.lastModifiedAtUtc,
              modifiedByDisplayName: offeringCategory.modifiedByDisplayName,
              modifiedByUserId: offeringCategory.modifiedByUserId,
            }}
          />
        </>
      )}
    </Drawer>
  );
};

export default OfferingCategoryViewDrawer;
